import React, { Component } from 'react';
import CustomModal from '.';
import ColorButton from '../Buttons/ColorButton';
import { Group, Stack } from '@mantine/core';

// Mirrors MessageTemplateDeletionConfirmationModal.jsx's shape — a small, self-contained
// confirmation modal with copy written for this specific context, rather than reusing the
// generic DeleteModal.js (its German copy is hardcoded to "dieses Dokument", wrong for a
// chat thread).
export class ChatThreadDeleteConfirmationModal extends Component {
  render() {
    const { open, toggle, className, onConfirm, deletionInProgress } = this.props;

    return (
      <CustomModal
        heading={'Unterhaltung löschen'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => toggle()}
        className={`${className}`}
      >
        <Stack>
          <Group>
            <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: '400' }}>Sind Sie sicher, dass Sie diese Unterhaltung unwiderruflich löschen wollen? Der gesamte Chatverlauf geht dabei verloren.</span>
          </Group>
          <Group justify="space-between">
            <div>
              <ColorButton
                text={'Abbrechen'}
                className='gray-btn'
                onClick={() => toggle()}
              />
            </div>
            <div>
              <ColorButton
                text={'Löschen'}
                className='red-btn'
                showLoader={deletionInProgress}
                disabled={deletionInProgress}
                onClick={() => onConfirm()}
              />
            </div>
          </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default ChatThreadDeleteConfirmationModal;
